import styled from 'styled-components';

import { SectionTitle } from '../../components';

/** Page column — sections stack 32px apart inside the layout slot. */
export const OpsPage = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

/**
 * A titled section. Block flow so the heading's own bottom margin is the only gap
 * between it and its content (no double-counting with a flex gap).
 */
export const Section = styled.div``;

/**
 * This page's heading. 16px below it rather than the shared SectionTitle's 18px,
 * which sixteen other files render: this page's spacing is not a reason to reflow
 * all of them.
 *
 * Extends the component through its public `className` rather than reaching into
 * `SectionTitle/SectionTitle.styles` for a component selector. That import worked,
 * but it coupled this page to a claim-guarded component's private module: a rename
 * would at least fail the build, while a reshape (wrapping `Root` in a new outer
 * element) would silently retarget the selector and quietly restore 18px here, with
 * nothing failing.
 */
export const OpsSectionTitle = styled(SectionTitle)`
  margin-bottom: 16px;
`;

/** Groups the two Automated-Operations panels (stats + live feed) under one title. */
export const PanelGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
